import { a as o } from "./chunk-BaseElement-CJM6sCUz.js";
class l extends o {
  constructor() {
    super();
  }
  connectedCallback() {
    super.connectedCallback(), this.summary = this.querySelector("summary"), this.summary.addEventListener("click", this.addAnimationHandler.bind(this)), this.closeSiblings = this.hasAttribute("data-close-siblings");
  }
  addAnimationHandler(a) {
    const n = this.summary.parentElement, t = this.summary.nextElementSibling;
    if (t.classList.contains("animation")) {
      t.classList.remove("animation", "collapsing");
      return;
    }
    const i = (s) => t.addEventListener("animationend", s, { once: !0 });
    requestAnimationFrame(() => t.classList.add("animation")), i(() => t.classList.remove("animation")), n.getAttribute("open") !== null && (a.preventDefault(), t.classList.add("collapsing"), i(() => {
      n.removeAttribute("open"), t.classList.remove("collapsing");
    })), this.closeSiblings && this.parentElement.querySelectorAll("details").forEach((e) => {
      e !== n && e.hasAttribute("open") && (e.removeAttribute("open"), e.querySelector("div").classList.remove("animation", "collapsing"));
    });
  }
}
window.customElements.define("animated-accordion", l);
export {
  l as AnimatedAccordion
};
